import React from 'react';
import { Routes, Route } from 'react-router-dom';
import HomePage from './HomePage';
import PrivacyPolicy from './PrivacyPolicy';
import TermsOfService from './TermsOfService';
import './App.css';

function App() {
	return (
		<Routes>
			<Route path="/" element={<HomePage />} />
			<Route path="/privacybeleid" element={<PrivacyPolicy />} />
			<Route path="/gebruikersvoorwaarden" element={<TermsOfService />} />
		</Routes>
	);
}

export default App;
